import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";

const MOBILE_BREAKPOINT = 768;

const DesktopOnlyRoute = ({ children }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < MOBILE_BREAKPOINT);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (isMobile) return <Navigate to="/mobileblock" replace />;
  return children;
};

export default DesktopOnlyRoute;
